module.exports = __webpack_public_path__ + "static/img/shezhi_vip.9697f1c2.png";